var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from 'react';
import { useEmail, emailValues } from './Email';
import { useBilling, billingValues } from './Billing';
import { useShipping, shippingValues } from './Shipping';
import { useCard, cardValues } from './Card';
import { addError, createFieldNameMap, getValuesOrErrors as gve } from '../../../utils/form';
var PaymentContext = createContext(null);
var formGroupValues = [emailValues, billingValues, shippingValues, cardValues];
var fieldNameMap = createFieldNameMap(formGroupValues);
export var PaymentProvider = function (_a) {
    var appearing = _a.appearing, children = _a.children;
    var paymentRef = useRef(null);
    var emailCtx = useEmail();
    var cardCtx = useCard();
    var billingCtx = useBilling();
    var shippingCtx = useShipping();
    var formGroupCtxs = {
        email: emailCtx,
        card: cardCtx,
        billing: billingCtx,
        shipping: shippingCtx,
    };
    var handleFocus = function (ev) {
        var name = ev.target.name;
        Object.values(formGroupCtxs).forEach(function (ctx) {
            if (ctx.formValues[name]) {
                ctx.handleFocus(paymentRef.current, ev);
            }
        });
    };
    var handleInput = function (ev) {
        var name = ev.target.name;
        Object.values(formGroupCtxs).forEach(function (ctx) {
            if (ctx.formValues[name]) {
                ctx.handleInput(paymentRef.current, ev);
            }
        });
    };
    var handleBlur = function (ev) {
        var name = ev.target.name;
        Object.values(formGroupCtxs).forEach(function (ctx) {
            if (ctx.formValues[name]) {
                ctx.handleBlur(paymentRef.current, ev);
            }
        });
    };
    var handleChange = function (ev) {
        var name = ev.target.name;
        Object.values(formGroupCtxs).forEach(function (ctx) {
            if (ctx.formValues[name]) {
                ctx.handleChange(paymentRef.current, ev);
            }
        });
    };
    var getValuesOrErrors = function () {
        var values = {};
        for (var key in formGroupCtxs) {
            var ctx = formGroupCtxs[key];
            var res = gve(paymentRef.current, ctx.formValues);
            for (var _i = 0, _a = res.errorElements; _i < _a.length; _i++) {
                var element = _a[_i];
                addError(element);
            }
            if (res.hasRequiredError) {
                ctx.setShowRequired(true);
            }
            values[key] = res;
        }
        return values;
    };
    var findField = function (field) {
        if (paymentRef.current) {
            var fieldName = fieldNameMap.get(field);
            var element = paymentRef.current[fieldName || field];
            if (element)
                return element;
        }
        return undefined;
    };
    return (_jsx(PaymentContext.Provider, __assign({ value: {
            appearing: appearing,
            paymentRef: paymentRef,
            handleFocus: handleFocus,
            handleBlur: handleBlur,
            handleInput: handleInput,
            handleChange: handleChange,
            findField: findField,
            getValuesOrErrors: getValuesOrErrors,
        } }, { children: children })));
};
export var usePayment = function () {
    var context = useContext(PaymentContext);
    if (!context)
        throw new Error('PaymentProvider not found in root');
    return context;
};
//# sourceMappingURL=Payment.js.map